<template>
  <div class="generalize">
    <div class="generalize-height">
      <p class="generalize-back">发送海报给好友，好友付款返佣金</p>
      <img class="backgroundImage-image" :src="posterImg" alt />
      <!-- <div class="tui ">
        <div id="posterHtml" ref="posterHtml" :style="{backgroundImage: 'url('+posterHtmlBg+')'}">
          <img class="posterHtml-image" :src="avatar" alt />
          <span>{{nickname}}</span>
          <p>我在参与开三支付的活动中获得一个大红包，你也快来参与吧~</p>

          <img class="posterHtml-code" :src=" this.$store.state.baseURL + 'user/sms/builderPersonQrcode?token='+token" />
          <p>扫码加入</p>
        </div>
      </div>-->
      <i class="generalize-backimage"></i>
      <p>长按或截图保存到手机</p>
    </div>
  </div>
</template>

<script>
import {Toast} from 'vant'

import { getUserToken } from "@/utils/Cookie";
import { request } from "@/utils/https";
export default {
  name: "generalize",

  data() {
    return {
      nickname: "", //文案内容
      avatar: "", // 头像
      posterHtmlBg: require("@/assets/image/bg-small.png"), // 背景图
      posterImg: "", // 最终生成的海报图片
      bg_big: "",
      token: ""
    };
  },
  created() {
    this.token = getUserToken();
    if (this.$route.query.nickname) {
      this.nickname = this.$route.query.nickname;
    }
    if (this.$route.query.avatar) {
      this.avatar = this.$route.query.avatar;
    }
  },
  async mounted() {
    let data = {
      avatar: this.avatar
    };
    let res = await request(
      "user/sms/builderPersonQrcode?token=" + this.token,
      data
    );
    if (res.error == 0) {
      // console.log(res);
      this.posterImg = res.data.url;
    } else {
      Toast(res.error_reason);
    }
  }
};
</script>
<style lang="scss" scoped>
.backgroundImage-image {
  width: 100%;
  border-radius: .4375rem;
  margin-bottom: 1.0625rem;
}
.tui {
  // width: 100%;
  -webkit-overflow-scrolling: touch;
  // height: 26.34375rem;
  border-radius: 0.5rem;
  opacity: 1;
  margin-bottom: 1.6625rem;
  // position: absolute;
  #posterHtml {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    overflow: hidden;
    text-align: center;
    .posterHtml-image {
      display: block;
      width: 5rem;
      height: 5rem;
      background: rgba(255, 255, 255, 1);
      border-radius: 50%;
      margin: 1.6625rem auto;
    }
    span {
      font-size: 1.0625rem;
      font-family: PingFangHK-Medium, PingFangHK;
      // font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    p {
      padding: 0.95rem 1.875rem 1.5625rem 1.875rem;
      font-size: 1rem;
      font-family: PingFangHK-Regular, PingFangHK;
      // font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .posterHtml-code {
      width: 9.75rem;
      height: 9.75rem;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.5rem;
      margin-top: 0.978125rem;
      margin-bottom: 0.78125rem;
    }
    p:last-child {
      padding-top: 0.85625rem;
      padding-bottom: 1.55rem;
      font-size: 0.8125rem;
      font-family: PingFangHK-Regular, PingFangHK;
      // font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
.generalize {
  width: 100%;
  height: 100%;
  background: rgba(215, 233, 255, 1);
  position: absolute;
  overflow: hidden;
  .generalize-height {
    padding: 2.53125rem 1.5625rem 3.125rem 1.5625rem;
    overflow: hidden;
    text-align: center;
    .generalize-back {
      text-align: center;
      bottom: 0px;
      padding-bottom: 0.75rem;
    }
    .generalize-backimage {
      display: inline-block;
      width: 0.806875rem;
      height: 0.806875rem;
      background: url("../../assets/image/lALPGpqNbD.png");
      background-size: 100% 100%;
    }
    p:last-child {
      padding-top: 0.25rem;
      font-size: 1rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
  }
}
</style>
